import { useMutation } from '@apollo/client'

import {
   convertToErrorType,
   CustomError,
   getAPIStatus
} from '@flowwai-frontend/bps-officer-web/common/data-access'
import { AskQueryInThreadParams } from '@flowwai-frontend/bps-officer-web/graphql'
import { MessageModel } from '@flowwai-frontend/shared-web/ai-chat-support/data-access'

import {
   AskQueryInThreadMutation as Mutation,
   AskQueryInThreadDocument as MutationDocument,
   AskQueryInThreadMutationVariables as MutationVariables
} from './mutation.generatedTypes'
import useAPIResponseHandler from './responseHandler'

export interface FailureArgsType {
   data?: CustomError<Mutation['askQueryInThread']>
   error?: Error | null
}

interface TriggerAPIArgsType {
   requestObj: AskQueryInThreadParams

   onFailure?: (args: FailureArgsType) => void
   onSuccess?: (message: MessageModel) => void
}

export const useAskQueryInThread = () => {
   const [askQueryInThread, { error, loading }] = useMutation<
      Mutation,
      MutationVariables
   >(MutationDocument)

   const { handleAPIResponse } = useAPIResponseHandler()

   const triggerAPI = (args: TriggerAPIArgsType): void => {
      askQueryInThread({
         fetchPolicy: 'network-only',
         variables: {
            params: args.requestObj
         },
         onError: error => {
            args.onFailure?.({ error })
         },
         onCompleted: data =>
            handleAPIResponse({
               data,
               onFailure: (
                  errorMessage: string,
                  data: Mutation['askQueryInThread']
               ) =>
                  args.onFailure?.({
                     data: new CustomError(errorMessage, data)
                  }),
               onSuccess: args.onSuccess
            })
      })
   }

   const apiError = convertToErrorType(error)

   const apiStatus = getAPIStatus({
      isError: Boolean(error),
      isLoading: loading
   })

   return {
      apiError,
      apiStatus,
      triggerAPI
   }
}
